import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService, User } from '../../../core/service/auth/auth.service';

const PAGE_TITLES: Record<string, string> = {
  'dashboard':    'Tableau de bord',
  'competitions': 'Compétitions',
  'calendrier':   'Calendrier',
  'clubs':        'Clubs',
  'arbitres':     'Arbitres',
  'delegues':     'Délégués',
  'equipes':      'Mes équipes',
  'resultats':    'Résultats',
  'feuilles':     'Feuilles de match',
  'rapports':     'Rapports',
  'mes-matchs':   'Mes matchs',
};

const PAGE_SUBTITLES: Record<string, string> = {
  'dashboard':    'Bienvenue sur la plateforme de gestion des compétitions',
  'competitions': 'Gestion et suivi des compétitions',
  'calendrier':   'Planning et programmation des matchs',
  'clubs':        'Clubs participants aux compétitions',
  'arbitres':     'Corps arbitral de la fédération',
  'delegues':     'Délégués officiels',
  'equipes':      'Gestion de vos équipes',
  'resultats':    'Résultats et classements',
  'feuilles':     'Feuilles de match officielles',
  'rapports':     'Rapports officiels de délégation',
  'mes-matchs':   'Matchs qui vous sont assignés',
};

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: User | null = null;
  federationLogoUrl: string | null = null;
  pageTitle = '';
  pageSubtitle = '';

  private destroy$ = new Subject<void>();

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.currentUser = user;
    });

    const fed = this.authService.getFederation();
    if (fed?.logo_url) this.federationLogoUrl = fed.logo_url;

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: any) => this.resolvePage(e.urlAfterRedirects || e.url));

    this.resolvePage(this.router.url);
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  private resolvePage(url: string): void {
    const segments = url.split('/').filter(Boolean);
    const segment = segments[segments.length - 1]?.split('?')[0] ?? '';
    this.pageTitle    = PAGE_TITLES[segment]    ?? 'Compétition';
    this.pageSubtitle = PAGE_SUBTITLES[segment] ?? '';
  }

  logout(): void {
    this.authService.logout().subscribe({
      complete: () => this.router.navigate(['/accueil']),
    });
  }
}
